"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Karen = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const SelectCard_1 = require("../../inputs/SelectCard");
const Resources_1 = require("../../Resources");
class Karen extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.KAREN,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L11',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.opgArrow().text('X').prelude().asterix();
                }),
                description: 'Once per game, draw Prelude cards equal to the current generation number and choose one to play.',
            },
        });
        this.isDisabled = false;
    }
    play() {
        return undefined;
    }
    canAct() {
        return this.isDisabled === false;
    }
    action(player) {
        const cardsDrawn = [];
        const game = player.game;
        for (let i = 0; i < game.generation; i++) {
            cardsDrawn.push(game.dealer.dealPreludeCard(game));
        }
        cardsDrawn.forEach((card) => {
            Card_1.Card.setUnplayablePreludeWarningText(card, player);
        });
        return new SelectCard_1.SelectCard('Choose prelude card to play', 'Play', cardsDrawn, (foundCards) => {
            if (foundCards[0].canPlay === undefined || foundCards[0].canPlay(player)) {
                this.isDisabled = true;
                return player.playCard(foundCards[0]);
            }
            else {
                game.log('${0} was discarded for 15 M€ as ${1} could not afford to play it', (b) => b.card(foundCards[0]).player(player));
                this.isDisabled = true;
                player.addResource(Resources_1.Resources.MEGACREDITS, 15, { log: true });
                foundCards[0].warning = undefined;
                return undefined;
            }
        });
    }
}
exports.Karen = Karen;
//# sourceMappingURL=Karen.js.map